export default __webpack_public_path__ + "static/media/covidBg.ca5265bd.jpg";